'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Typography = require('../Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * General all purpose text component with Wix styling.
  *
  * Adds correct styling so you don't have to.
  *
  * Renders correct element (either `span` or `h1` - `h5`) depending on `appearance` (defaults to `span`)
  */
var _class = function (_WixComponent) {
  _inherits(_class, _WixComponent);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getTitle = function () {
      var _this$props = _this.props,
          forceHideTitle = _this$props.forceHideTitle,
          ellipsis = _this$props.ellipsis,
          children = _this$props.children;


      return typeof children === 'string' && ellipsis && !forceHideTitle ? children : null;
    }, _this.getType = function (appearance) {
      return [{ type: 'h1', candidates: ['H0'] }, { type: 'h2', candidates: ['H1', 'H1.1'] }, { type: 'h3', candidates: ['H2', 'H2.1'] }, { type: 'h4', candidates: ['H3'] }, { type: 'h5', candidates: ['H4'] }].filter(function (_ref2) {
        var candidates = _ref2.candidates;
        return candidates.indexOf(appearance) !== -1;
      }).reduceRight(function (acc, _ref3) {
        var type = _ref3.type;
        return type;
      }, 'span');
    }, _this.getClassNames = function (appearance) {
      return [{ className: _styles2.default.headingDefaults, candidates: ['H0', 'H1', 'H1.1', 'H2', 'H2.1', 'H3', 'H4'] }].filter(function (_ref4) {
        var candidates = _ref4.candidates;
        return candidates.indexOf(appearance) !== -1;
      }).reduce(function (acc, _ref5) {
        var className = _ref5.className;
        return acc.concat(className);
      }, [_Typography2.default[(0, _Typography.convertFromUxLangToCss)(appearance)]]).join(' ');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          ellipsis = _props.ellipsis,
          children = _props.children;


      return _react2.default.createElement(this.getType(appearance), {
        title: this.getTitle(),
        className: (0, _classnames2.default)(this.getClassNames(appearance), _defineProperty({}, _styles2.default.ellipsis, ellipsis))
      }, children);
    }
  }]);

  return _class;
}(_WixComponent3.default);

_class.displayName = 'Text';
_class.propTypes = {
  /** a name of appearance to apply */
  appearance: _propTypes2.default.oneOf(['H0', 'H1', 'H1.1', 'H2', 'H2.1', 'H3', 'H4', 'T1', 'T1.1', 'T1.2', 'T1.3', 'T1.4', 'T2', 'T2.1', 'T2.2', 'T2.3', 'T3', 'T3.1', 'T3.2', 'T3.3', 'T3.4', 'T4', 'T4.1', 'T4.2', 'T4.3', 'T5', 'T5.1']),

  /** should the text be ellipsed or not */
  ellipsis: _propTypes2.default.bool,

  /** should hide the title tooltip that is shown on mouse hover when using the ellipsis prop */
  forceHideTitle: _propTypes2.default.bool,

  /** any nodes to be rendered (usually text nodes) */
  children: _propTypes2.default.node
};
_class.defaultProps = {
  appearance: 'T1.1'
};
exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Text/Text.js
// module id = 138
// module chunks = 0 1